import { IteratorExpression } from '../Expression.js';
import { Utils } from '../../Utils.js';
export class ExistsExpression extends IteratorExpression {
    evaluate(visitor, localVariables) {
        const collection = this.getSource()
            .evaluate(visitor, localVariables);
        if (collection instanceof Array) {
            return collection.some(c => {
                const variables = {};
                if (this.getIterators()) {
                    variables[this.getIterators()[0]] = c;
                }
                else {
                    const variableName = Utils.getVariableName(this);
                    variables[variableName.getVariable()] = c[variableName.getVariable()];
                }
                const visitResult = this.getBody().evaluate(visitor, Object.assign(Object.assign({}, localVariables), variables));
                return visitResult === true;
            });
        }
        else {
            return false;
        }
    }
}
//# sourceMappingURL=ExistsExpression.js.map